import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Guid } from '@web/utils';
import {
  TableBuilderFactory,
  TableComponent,
  TableConfig,
  TableDataPayload,
} from '@web/shared/ui';
import { Observable } from 'rxjs';
import { AdminProductQuantityHistoryListItemAction } from '../../enums/admin-product-quantity-history-list-item-action';
import { AdminProductQuantityHistoryCollectionFilter } from '../../models/admin-product-quantity-history-collection-filter';
import { AdminProductQuantityHistoryReasonTypeProviderService } from '../../providers/admin-product-quantity-history-reason-type-provider.service';
import { AdminProductQuantityHistoryCollectionItem } from '../../models/admin-product-quantity-history-collection-item';
import { AdminProductQuantityHistoryListCustomCellTemplateComponent } from '../../components/admin-product-quantity-history-list-custom-cell-template/admin-product-quantity-history-list-custom-cell-template.component';
import { AdminProductDataSourceService } from '@web/features/product';

@Component({
  selector: 'app-admin-product-quantity-history-list',
  imports: [
    AdminProductQuantityHistoryListCustomCellTemplateComponent,
    TableComponent,
  ],
  templateUrl: './admin-product-quantity-history-list.component.html',
  styleUrl: './admin-product-quantity-history-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminProductQuantityHistoryListComponent {
  /* prettier-ignore */
  private readonly tableBuilder = inject(TableBuilderFactory<AdminProductQuantityHistoryCollectionItem, AdminProductQuantityHistoryCollectionFilter, AdminProductQuantityHistoryListItemAction>).create();
  /* prettier-ignore */
  private readonly reasonTypeProvider = inject(AdminProductQuantityHistoryReasonTypeProviderService);
  private readonly dataSource = inject(AdminProductDataSourceService);

  public readonly id = input.required<Guid>();

  protected readonly config = this.buildTable();

  private buildTable(): TableConfig<
    AdminProductQuantityHistoryCollectionItem,
    AdminProductQuantityHistoryCollectionFilter,
    AdminProductQuantityHistoryListItemAction
  > {
    // prettier-ignore
    return this.tableBuilder
      .dataKey('id')
      .columns((builder) => [
        builder
          .initCustom('change')
          .width('14rem')
          .label('Ilość')
          .build(),

        builder
          .initCustom('createdAt')
          .width('14rem')
          .filterKey('createdAt')
          .sortKey('createdAt')
          .label('Data zmiany')
          .build(),

        builder
          .initText('createdBy')
          .width('16rem')
          .filterKey('createdBy')
          .sortKey('createdBy')
          .label('Autor')
          .build(),

        builder
          .initCustom('reason')
          .width('18rem')
          .filterKey('reason')
          .sortKey('reason')
          .label('Powód zmiany')
          .build(),

        builder
          .initCustom('order')
          .width('12rem')
          .filterKey('order')
          .sortKey('order')
          .label('Zamówienie')
          .build(),
      ])
      .filters((builder) => [
        builder
          .initNumber('change')
          .build(),
        builder
          .initSelect('reason')
          .dictionary(() => this.reasonTypeProvider.selectItems())
          .build(),
        builder
          .initDateRange('createdAt')
          .build(),
        builder
          .initText('createdBy')
          .build(),
        builder
          .initText('order')
          .build(),
      ])
      .dataSource({ fetch: (lazyLoad): Observable<TableDataPayload<AdminProductQuantityHistoryCollectionItem>> => this.dataSource.fetchQuantityHistoryCollection(this.id(), lazyLoad)})
      .build();
  }
}
